module.exports = __webpack_public_path__ + "img/V33.5bcfde99.jpg";